import { createReporter } from 'whisper-core-api';

const reporter = createReporter('[nudge-renderer-utils]');

export const captureMessage = reporter.captureMessage;
export const captureError = reporter.captureError;
export const captureWarn: typeof captureError = (message, error, options?) => {
  captureError(message, error, { ...options, level: 'warning' });
};
